import React from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { hasPortalSession } from "./routeSession";

export { hasPortalSession } from "./routeSession";

// Public authentication and policy routes sit outside this boundary. All
// protected portal routes pass through it before their page components mount,
// so an expired/missing browser session cannot briefly render private content.
export const PortalAuthGuard = ({ loginPath, role }) => {
  const location = useLocation();

  if (!hasPortalSession(role)) {
    return (
      <Navigate
        to={loginPath}
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  }

  return <Outlet />;
};

export const PortalPublicOnly = ({ children, homePath, role }) =>
  hasPortalSession(role) ? <Navigate to={homePath} replace /> : children;

export const PortalNotFound = ({ homePath, portalName = "Portal" }) => {
  const navigate = useNavigate();

  return (
    <main
      role="main"
      className="d-flex align-items-center justify-content-center text-center px-3"
      style={{ minHeight: "100vh", background: "#f2f2f2", color: "#344f85" }}
    >
      <section>
        <div style={{ fontSize: "64px", fontWeight: 700, lineHeight: 1 }}>404</div>
        <h1 className="h3 mt-3">Page not found</h1>
        <p className="text-dark">The requested {portalName} page does not exist.</p>
        <button
          type="button"
          className="btn btn-primary px-4"
          onClick={() => navigate(homePath, { replace: true })}
        >
          Back to home
        </button>
      </section>
    </main>
  );
};

export const GlobalNotFound = () => (
  <PortalNotFound homePath="/user/login" portalName="application" />
);
